export default "__VITE_ASSET__CJ33qDEm__"